import { objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

const srpCitiesCrawlPathsDuck = objectDuckCreator({
    ...srpDuckPreset,
    store: 'srpCitiesCrawlPaths',
    initialState: {
        citiesData: {},
    },
});

export default srpCitiesCrawlPathsDuck;
